import { CheckCircle2, Circle, Clock3 } from "lucide-react";

export type PayoutLineStatus = "paid" | "pending" | null;

interface PayoutStatusBadgeProps {
  status: PayoutLineStatus;
  labels: {
    paid: string;
    pending: string;
    notRequested: string;
  };
}

export function PayoutStatusBadge({
  status,
  labels,
}: PayoutStatusBadgeProps): JSX.Element {
  if (status === "paid") {
    return (
      <span className="inline-flex items-center gap-1.5 rounded-full border border-emerald-400/30 bg-emerald-500/15 px-2.5 py-0.5 text-xs font-semibold text-emerald-300">
        <CheckCircle2 className="h-3 w-3" aria-hidden />
        {labels.paid}
      </span>
    );
  }
  if (status === "pending") {
    return (
      <span className="inline-flex items-center gap-1.5 rounded-full border border-amber-400/30 bg-amber-500/15 px-2.5 py-0.5 text-xs font-semibold text-amber-300">
        <Clock3 className="h-3 w-3" aria-hidden />
        {labels.pending}
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full border border-border bg-muted/30 px-2.5 py-0.5 text-xs font-medium text-muted-foreground">
      <Circle className="h-3 w-3" aria-hidden />
      {labels.notRequested}
    </span>
  );
}
